<template>
    <div class="top-header border">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 col-xs-9 text-left">
                <a href="http://dicta.org.il/index.html" target="_blank">
                  <em class="f black title dicta" style="font-style: normal;">{{title}}</em>
                  <span class="txt add f black">{{statement}}</span>
                </a>
              </div>

              <div class="col-sm-6 col-xs-3 text-right">
                <div class="btn-group dropdown pull-right">
                  <a href="#" class="link dropdown-toggle f black" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dicta Tools <img src="../assets/ic_down-black.png">
                  </a>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                    <li><a class="f black" target="_blank" href="http://search.dicta.org.il/"> <span><img class="img" src="../assets/img1.png"></span> Search the Bible </a></li>
                    <li><a class="f black" target="_blank" href="http://nakdan.dicta.org.il/"> <span><img class="img" src="../assets/img3.png"></span> Nakdan </a></li>
                    <li><a class="f black" target="_blank" href="http://tiberias.dicta.org.il"> <span><img class="img" src="../assets/img2.png"></span> Tiberias Stylistic Classifier</a></li>
                    <li><a class="f black" target="_blank" href="http://pasuk.dicta.org.il/"> <span><img class="img" src="../assets/tools_pasukfinder.png"></span> Pasuk Finder</a></li>
                    <li><a class="f black" target="_blank" href="http://synoptic.dicta.org.il/"> <span><img class="img" src="../assets/tools_synoptic.png"></span> Synoptic Builder</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    </div>
</template>
<script>
export default {
  name: 'AppHeader',
  data () {
    return {
      title: 'DICTA',
      statement: 'Analytical tools for Hebrew texts'
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
  .top-header{
    padding: 9px 0;
    height: 37px;
    background-color: #ffffff;
  }
  .top-header.border{
    border-bottom: solid 1px #dfdfdf;
  }
  .top-header .dicta{
    font-size: 18px;
    line-height: 21px;
    margin: 0 9px 0 0;
    display: inline-block;
    vertical-align: middle;
  }
  .top-header .txt.add{
    font-size: 12px;
    line-height: 15px;
    display: inline-block;
    vertical-align: middle;
    padding: 2px 0 0;
  }
  .top-header .txt.add a{
    text-decoration: underline;
  }
  .top-header .link{
    text-decoration: none;
    font-size: 12px;
    line-height: 15px;
    box-shadow: none;
    padding: 0;
    margin: 6px 0 0;
    display: block;
  }
  .top-header .link:active,
  .top-header .link:focus,
  .top-header .link:hover{
    color: #000 !important;
    box-shadow: none !important;
  }
  .top-header .btn-group.open .dropdown-toggle{
    box-shadow: none;
  }
  .top-header .link img{
    display: inline-block;
    vertical-align: middle;
    margin: 0 0 0 2px;
  }
  .top-header .btn-group{
    vertical-align: top;
    margin: -2px 0 0;
  }
  .top-header .dropdown{
    width: 157px;
  }
  .top-header .dropdown-menu{
    width: 190px;
    height: 158px;
    background-color: #ffffff;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
    border: solid 1px #e7e7e7;
    text-align: left;
    padding: 0 16px;
    margin: 12px 0 0;
    border-radius: 0;
    left: 24px;
  }

  .top-header .dropdown-menu:after, .top-header .dropdown-menu:before {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .top-header .dropdown-menu:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #fff;
    border-width: 10px;
    margin-left: -10px;
  }
  .top-header .dropdown-menu:before {
    border-color: rgba(231, 231, 231, 0);
    border-bottom-color: #e7e7e7;
    border-width: 11px;
    margin-left: -11px;
  }

  .top-header .dropdown-menu li{
    font-size: 14px;
    line-height: 17px;
    border-top: solid 1px #d8d8d8;
  }
  .top-header .dropdown-menu li:first-child{
    border:none;
  }
  .top-header .dropdown-menu li a{
    display: block;
    font-size: 14px;
    padding: 14px 0 14px 5px;
  }
  .top-header .dropdown-menu li a:hover,
  .top-header .dropdown-menu li.active a{
    border-radius: 0;
    background-color: inherit;
  }
  .top-header .dropdown-menu li span{
    width: 25px;
    display: inline-block;
    vertical-align: middle;
  }
  .top-header .dropdown-menu li img{
    display: inline-block;
    vertical-align: middle;
    margin: 0 5px 0 0;
  }*/

</style>



// WEBPACK FOOTER //
// src/components/appHeader.vue